import styled from 'styled-components'

const Hr = ({ height = "1px", color = "#888" }) => {

    return (

        <Wrap $lineColor={color} $height={height} />

    )
}

export default Hr

const Wrap = styled.hr`

border: none;
 border-color: ${(props) => props.$lineColor};
 border-top-width: ${(props) => props.$height};
 border-top-style: solid;
 margin-block: 10px!important;
 width: 70%;
/* height: 10px;   */

  overflow: visible;
  text-align: center;

`